module.exports = __webpack_public_path__ + "img/Courseware.89eec335.png";